<template>
  <label :class="c()">
    <input
      v-model="innerValue"
      :value="htmlValue"
      :class="c('control')"
      type="radio"
      v-bind="$attrs"
    >
    <slot />
  </label>
</template>

<script>
import {cn} from '@/app/js/classname'

const c = cn('answer-option')

export default {
  name: 'AnswerOption',
  inheritAttrs: false,
  props: {
    value: {
      type: String,
      default: null
    },
    htmlValue: {
      type: String,
      default: null
    }
  },
  emits: ['input'],
  data() {
    return {
      innerValue: this.value
    }
  },
  watch: {
    innerValue() {
      this.$emit('input', this.innerValue)
    },
    value() {
      this.innerValue = this.value
    }
  },
  methods: {
    c,
  }
}
</script>

<style lang="scss">
.answer-option {
  --border: #E0B453;
  --focus: #ba8a09;
  --active: #E0B453;
  --disabled: #f6f8ff;
  --border-hover: #E0B453;
  --size: 17px;

  display: flex;
  align-items: center;
  gap: 16px;
  padding: 7px 10px;
  color: #545454;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.6;
  background: #FFFFFF;
  border: 1px solid #E4E4E4;
  border-radius: 6px;
  cursor: pointer;

  input {
    position: relative;
    display: inline-flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    width: var(--size);
    height: var(--size);
    margin: 0;
    border: 1px solid var(--bc, var(--border));
    border-radius: 1px;
    transition: background 0.3s, border-color 0.3s, box-shadow 0.2s;
    -webkit-appearance: none;
    -moz-appearance: none;

    &:focus {
      outline-color: var(--focus);

      &::placeholder {
        opacity: 0.7;
      }
    }

    &:disabled {
      cursor: not-allowed;
      opacity: 0.6;
    }

    &:hover {
      &:not(:disabled) {
        --bc: var(--border-hover);
      }
    }

    &[type='radio'] {
      border-radius: 50%;

      &::after {
        position: absolute;
        display: block;
        width: calc(var(--size) / 3);
        height: calc(var(--size) / 3);
        background: #fff;
        border-radius: 50%;
        opacity: 0;
        transition: transform var(--d-t, 0.3s) var(--d-t-e, ease),
        opacity var(--d-o, 0.2s);
        content: '';
      }

      &:checked {
        background-color: var(--active);
        border-color: var(--active);

        &::after {
          opacity: 1;
        }
      }
    }
  }
}
</style>
